import { tokens } from "../../../public/tokens.js";

export const courseStyles = {
    chipBase: {
        display: "flex",
        height: "18px",
        padding: "4px 8px",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: tokens.globals["border-radius"],
        fontSize: tokens.typography.fontSize["sm-10px"],
        fontWeight: tokens.typography.fontWeights.semibold,
    }
}